import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["payFrequency", "annualIncome", "annualIncomeEstimate", "annualIncomeWarning"];

  connect() {
    const firstError = this.element.querySelector('.has-form-input-error');
    if (firstError) {
      firstError.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  toggleAnnualIncomeWarning() {
    const income = this.annualIncomeTarget.value;
    if (!income) {
      this.annualIncomeEstimateTarget.style.display = "none";
      this.annualIncomeWarningTarget.style.display = "none";
      return;
    }

    const frequency = this.payFrequencyTarget.value;
    const numeric = Number(income.replace(/[\$,]/g, ''));

    if (numeric <= 20000) {
      if (frequency) {
        const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
        let frequencyLabel;

        switch (frequency) {
          case 'monthly':
            frequencyLabel = `That equals <b>${formatter.format(numeric / 12)} / month</b>`
            break;
          case 'semi_monthly':
            frequencyLabel = `That equals <b>${formatter.format(numeric / 24)} / semi-monthly</b>`
            break;
          case 'biweekly':
            frequencyLabel = `That equals <b>${formatter.format(numeric / 26)} / biweekly</b>`
            break;
          case 'weekly':
            frequencyLabel = `That equals <b>${formatter.format(numeric / 52)} / weekly</b>`
            break;
        }

        if (frequencyLabel) {
          this.annualIncomeEstimateTarget.innerHTML = frequencyLabel;
          this.annualIncomeEstimateTarget.style.display = "block";
          this.annualIncomeWarningTarget.style.display = "none";
        } else {
          this.annualIncomeEstimateTarget.innerHTML = '';
          this.annualIncomeEstimateTarget.style.display = "none";
          this.annualIncomeWarningTarget.style.display = "block";
        }
      } else {
        this.annualIncomeEstimateTarget.style.display = "none";
        this.annualIncomeWarningTarget.style.display = "block";
      }
    } else {
      this.annualIncomeEstimateTarget.style.display = "none";
      this.annualIncomeWarningTarget.style.display = "none";
    }
  }
}
